import { ACTIONS } from 'src/app/core/utils/actions.constants';
import { COMMONS } from 'src/app/core/utils/commons.constants';

export const HOME_CONSTANTS = {
  id: 'home',
  title: 'Agenda',

  labels: {
    ...COMMONS,
    patient: 'Paciente',
    doctor: 'Doctor',
    specialty: 'Especialidad'
  },

  actions: {
    ...ACTIONS,
    edit: `${ACTIONS.edit} Turno`,
    add: `${ACTIONS.add} Turno`,
    care: 'Atender Consulta'
  }
};
